import { useEffect, useState } from 'react';
import { apiRequest } from '../lib/api';

const FALLBACK = { signupEnabled: false, features: { blogs: { enabled: false, allowStudentPosts: false } } };
let pending = null;
let loaded = null;

function loadSettings() {
  if (!pending) {
    pending = apiRequest('/auth/v2/tenant-settings').then((response) => {
      if (!response.success) {
        pending = null;
        return FALLBACK;
      }
      loaded = {
        signupEnabled: response.data?.signupEnabled === true,
        features: {
          blogs: {
            enabled: response.data?.features?.blogs?.enabled === true,
            allowStudentPosts: response.data?.features?.blogs?.allowStudentPosts === true,
          },
        },
      };
      return loaded;
    });
  }
  return pending;
}

export function useTenantSettings() {
  const [settings, setSettings] = useState(loaded);

  useEffect(() => {
    let cancelled = false;
    loadSettings().then((value) => {
      if (!cancelled) setSettings(value);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return settings;
}

export function useFeatureEnabled(feature) {
  const settings = useTenantSettings();
  return settings ? settings.features[feature]?.enabled === true : null;
}
